import React from 'react';
import { Form, Input } from 'antd';
import PropTypes from 'prop-types';
import InputValidationMessage from '../../components/InputMessageContainers/InputValidationMessage';

const PasswordSetup = (props) => {
  const { validationStatus } = props;
  return (
    <>
      <Form.Item
        label="New Password"
        name="password"
        className="login-field no-margin-bottom"
        rules={[
          {
            required: true,
            message: (
              <InputValidationMessage message="Please enter your password" />
            ),
          },
          () => ({
            validator(_, value) {
              if (!value || value.length < 30) {
                return Promise.resolve();
              }
              // eslint-disable-next-line prefer-promise-reject-errors
              return Promise.reject(
                <InputValidationMessage message="Password can not contain more than 30 characters" />
              );
            },
          }),
        ]}
      >
        <Input.Password
          className="login-field"
          placeholder="New password (with the required complexity)"
        />
      </Form.Item>

      <div className="password-complexity-guide">
        <ul>
          <li className={validationStatus.hasLowerCase ? 'satisfied' : ''}>
            <i className="icon fi flaticon-tick" />A lower case letter
          </li>
          <li className={validationStatus.hasUpperCase ? 'satisfied' : ''}>
            <i className="icon fi flaticon-tick" />
            An upper case letter
          </li>
          <li className={validationStatus.hasNumber ? 'satisfied' : ''}>
            <i className="icon fi flaticon-tick" />A number
          </li>
          <li
            className={validationStatus.hasSpecialCharacter ? 'satisfied' : ''}
          >
            <i className="icon fi flaticon-tick" />A special character
          </li>
          <li className={validationStatus.hasMinLength ? 'satisfied' : ''}>
            <i className="icon fi flaticon-tick" />
            At least 8 characters
          </li>
        </ul>
      </div>
      <Form.Item
        label="Confirm Password"
        name="confirmPassword"
        className="login-field password"
        dependencies={['password']}
        rules={[
          {
            required: true,
            message: (
              <InputValidationMessage message="Please confirm your password" />
            ),
          },
          ({ getFieldValue }) => ({
            validator(_, value) {
              if (!value || getFieldValue('password') === value) {
                return Promise.resolve();
              }
              // eslint-disable-next-line prefer-promise-reject-errors
              return Promise.reject(
                <InputValidationMessage message="The two passwords that you entered do not match" />
              );
            },
          }),
        ]}
      >
        <Input.Password
          className="login-field"
          placeholder="Re enter your password here"
        />
      </Form.Item>
    </>
  );
};

export default PasswordSetup;

PasswordSetup.defaultProps = {
  validationStatus: {},
};
PasswordSetup.propTypes = {
  validationStatus: PropTypes.object,
};
